export default __webpack_public_path__ + "static/media/upwork.0c020665.svg";